var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "application-ratios finastra form-page mr-1" }, [
      _c(
        "div",
        { staticClass: "ratios-container mt-5 mt-lg-0" },
        [
          _c(
            "div",
            { staticClass: "d-flex align-items-center mb-2 ratios-title" },
            [
              _c("h6", { staticClass: "bold text-dark-gray mb-0" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("application.applicationRatios")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  ref: "reCalculate",
                  staticClass:
                    "badge status-badge application-status-badge re-calculate my-auto complete px-4 clickable",
                  on: {
                    click: function ($event) {
                      return _vm.reCalculate()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("application.actions.recalculate")) +
                      "\n        "
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ratios-scroll-wrapper px-2" },
            _vm._l(_vm.calculations, function (calculation, c_index) {
              return _c(
                "div",
                {
                  key: c_index,
                  staticClass: "calculations",
                  class: {
                    "mt-0 pt-0": c_index === 0,
                    "mt-2": c_index !== 0,
                    "calculations-title-container":
                      calculation.sectionType === "title",
                    "pt-3":
                      calculation.sectionType !== "value" && c_index !== 0,
                  },
                },
                [
                  calculation.sectionName
                    ? _c(
                        "h6",
                        {
                          staticClass: "bold mb-0 text-uppercase",
                          class: {
                            small: calculation.sectionType === "group",
                            "text-primary calculations-title":
                              calculation.sectionType !== "group",
                            heading: calculation.sectionType === "title",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " + _vm._s(calculation.sectionName)
                          ),
                          calculation.sectionType === "group"
                            ? _c("span", [_vm._v(":")])
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      staticClass:
                        "list-group list-group-flush finastra-steps bullet",
                    },
                    [
                      _vm._l(
                        calculation.values,
                        function (calculationValue, v_index) {
                          return _c(
                            "li",
                            {
                              key: v_index,
                              staticClass: "list-group-item d-flex pt-0 pr-3",
                              class: { dense: calculation.dense },
                            },
                            [
                              _c("value-section", {
                                attrs: {
                                  "calculation-value": calculationValue,
                                  "explanation-exists":
                                    _vm.explanationExists(calculationValue),
                                  "popover-window-options":
                                    _vm.getPopoverWindowOptions(
                                      calculationValue
                                    ),
                                  "value-text": String(
                                    _vm.getValueText(
                                      calculationValue.value,
                                      calculationValue.type
                                    )
                                  ),
                                },
                              }),
                            ],
                            1
                          )
                        }
                      ),
                      _vm._v(" "),
                      calculation.sectionType === "value"
                        ? _c(
                            "li",
                            { staticClass: "list-group-item d-flex pt-0 pr-3" },
                            [
                              _c("value-section", {
                                attrs: {
                                  "calculation-value": calculation.value,
                                  "explanation-exists": _vm.explanationExists(
                                    calculation.value
                                  ),
                                  "popover-window-options":
                                    _vm.getPopoverWindowOptions(
                                      calculation.value
                                    ),
                                  "value-text": String(
                                    _vm.getValueText(
                                      calculation.value.value,
                                      calculation.value.type
                                    )
                                  ),
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("complete-application-dropdown", {
            attrs: {
              "application-id": _vm.applicationId,
              "client-username": _vm.clientUsername,
            },
          }),
          _vm._v(" "),
          _vm.readonly
            ? _c("div", {
                staticClass: "overlay",
                attrs: { id: "application-ratios-overlay" },
              })
            : _vm._e(),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "finastra-expand-button d-xl-none d-flex" },
      [
        _c("i", {
          staticClass: "fa fa-calculator pt-0",
          attrs: { "aria-hidden": "true" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }